import { shareCourse } from '../core/backup.js';
import { dbPut } from '../core/db.js';
import { cardsOfCourse, cardsOfDeck, decksOf, dueCount, visCourses } from '../core/load.js';
import { state } from '../core/state.js';
import { $, $$, esc } from '../core/text.js';
import { smartImportModal } from '../io/transfer.js';
import { publishModal } from '../social/community.js';
import { courseModal, deckModal, delCourse, newCourse, newDeck } from './modal.js';
import { toast } from './toast.js';
import { refresh, setView } from './views.js';

/* ══════════ Sidebar ══════════ */
export function renderTree() {
  const tree = $('#course-tree');
  const list = visCourses();
  if (!list.length) {
    tree.innerHTML = '<p class="page-sub" style="padding:8px 4px">Noch keine Kurse.<br>Klick auf + oben.</p>';
    return;
  }
  tree.innerHTML = list.map((course) => {
    const decks = decksOf(course.id);
    const open = state.openCourses.has(course.id);
    const sel = state.selCourse === course.id && !state.selDecks.size && !state.coll;
    const cc = cardsOfCourse(course.id);
    const due = dueCount(cc);

    const deckRows = decks.map((d) => {
      const dsel = state.selDecks.has(d.id) && state.selCourse === course.id;
      const dc = cardsOfDeck(d.id);
      return `<div class="deck-row pc-${d.color || 0} ${dsel ? 'selected' : ''} ${d.archived ? 'archived' : ''}">
        <span class="deck-swatch"></span>
        <button class="deck-pick" data-deck="${d.id}" data-course="${course.id}" title="${esc(d.name)} · ${dc.length} Karten">
          <span>${dsel ? '✓' : '○'}</span>
          <span class="course-name">${esc(d.name)}${d.archived ? ' 📦' : ''}</span>
        </button>
        ${dueCount(dc) ? `<span class="badge due">${dueCount(dc)}</span>` : ''}
        <span class="badge">${dc.length}</span>
        <button class="deck-edit" data-edit-deck="${d.id}" title="Vorlesung bearbeiten">✎</button>
      </div>`;
    }).join('');

    return `<div class="course-item">
      <div class="course-head">
        <button class="course-row ${sel ? 'selected' : ''} ${course.archived ? 'archived' : ''}" data-course-row="${course.id}">
          <span class="caret ${open ? 'open' : ''}">▶</span>
          <span>${course.emoji || '📚'}</span>
          <span class="course-name">${esc(course.name)}${course.archived ? ' 📦' : ''}</span>
          ${due ? `<span class="badge due">${due}</span>` : ''}
          <span class="badge">${cc.length}</span>
        </button>
        <button class="tree-kebab" data-kebab-course="${course.id}" title="Mehr Optionen" aria-label="Mehr Optionen">⋮</button>
      </div>
      ${open ? `<div class="deck-list">
        ${deckRows}
        <button class="deck-mini" data-add-deck="${course.id}">+ Vorlesung</button>
        <button class="deck-mini" data-edit-course="${course.id}">✎ Kurs bearbeiten</button>
      </div>` : ''}
    </div>`;
  }).join('');

  $$('[data-course-row]').forEach((el) => {
    el.onclick = () => {
      const id = el.dataset.courseRow;
      if (state.selCourse === id && !state.coll) {
        state.openCourses.has(id) ? state.openCourses.delete(id) : state.openCourses.add(id);
      } else state.openCourses.add(id);
      state.selCourse = id; state.selDecks.clear(); state.coll = null;
      leaveSideView(); refresh();
    };
  });
  $$('[data-deck]').forEach((el) => {
    el.onclick = () => {
      const { deck, course } = el.dataset;
      if (state.selCourse !== course) { state.selCourse = course; state.selDecks.clear(); }
      state.coll = null;
      state.selDecks.has(deck) ? state.selDecks.delete(deck) : state.selDecks.add(deck);
      leaveSideView(); refresh();
    };
  });
  $$('[data-add-deck]').forEach((el) => { el.onclick = () => newDeck(el.dataset.addDeck); });
  $$('[data-edit-deck]').forEach((el) => { el.onclick = () => deckModal(el.dataset.editDeck); });
  $$('[data-edit-course]').forEach((el) => { el.onclick = () => courseModal(el.dataset.editCourse); });
  $$('[data-kebab-course]').forEach((el) => { el.onclick = (e) => { e.stopPropagation(); courseMenu(el.dataset.kebabCourse, el); }; });
}

/* Kleines Kontextmenü (⋮) an einem Anker-Element öffnen */
export function popMenu(anchor, items) {
  document.querySelector('.pop-menu')?.remove();
  const m = document.createElement('div');
  m.className = 'pop-menu';
  m.innerHTML = items.map((it) => it.sep ? '<div class="pop-sep"></div>'
    : `<button class="${it.danger ? 'danger' : ''}">${it.icon ? it.icon + ' ' : ''}${esc(it.label)}</button>`).join('');
  document.body.appendChild(m);
  const r = anchor.getBoundingClientRect();
  const mw = m.offsetWidth, mh = m.offsetHeight;
  let left = Math.min(r.left, window.innerWidth - mw - 8);
  let top = r.bottom + 4; if (top + mh > window.innerHeight - 8) top = Math.max(8, r.top - mh - 4);
  m.style.left = Math.max(8, left) + 'px'; m.style.top = top + 'px';
  const btns = [...m.querySelectorAll('button')];
  let bi = 0;
  items.forEach((it) => { if (it.sep) return; const b = btns[bi++]; if (b) b.onclick = () => { close(); it.fn?.(); }; });
  const close = () => { m.remove(); document.removeEventListener('mousedown', onDoc, true); document.removeEventListener('keydown', onKey, true); };
  const onDoc = (e) => { if (!m.contains(e.target)) close(); };
  const onKey = (e) => { if (e.key === 'Escape') close(); };
  setTimeout(() => { document.addEventListener('mousedown', onDoc, true); document.addEventListener('keydown', onKey, true); }, 0);
}

/* Kontextmenü eines Kurses: umbenennen, exportieren, veröffentlichen, archivieren, löschen */
export function courseMenu(courseId, anchor) {
  const c = state.courses.find((x) => x.id === courseId);
  if (!c) return;
  popMenu(anchor, [
    { icon: '✎', label: 'Umbenennen / bearbeiten', fn: () => courseModal(courseId) },
    { icon: '⬇', label: 'Als Datei exportieren', fn: () => shareCourse(courseId) },
    { icon: '📤', label: 'In Community veröffentlichen', fn: () => publishModal(courseId) },
    { sep: true },
    { icon: c.archived ? '↩' : '📦', label: c.archived ? 'Aus Archiv holen' : 'Archivieren', fn: async () => {
        c.archived = !c.archived; await dbPut('courses', c);
        if (c.archived && !state.showArchived && state.selCourse === courseId) { state.selCourse = null; state.selDecks.clear(); }
        toast(c.archived ? 'Kurs archiviert 📦' : 'Kurs zurückgeholt'); refresh();
      } },
    { icon: '✕', label: 'Kurs löschen', danger: true, fn: () => delCourse(courseId) },
  ]);
}

/* Menü am „+" neben „Kurse": neuen Kurs anlegen oder Karten importieren */
export function addCourseMenu(anchor) {
  popMenu(anchor, [
    { icon: '➕', label: 'Neuer Kurs', fn: newCourse },
    { icon: '⬆', label: 'Karten importieren (CSV · Anki · Quizlet)', fn: smartImportModal },
  ]);
}

export function leaveSideView() {
  if (['cards', 'collections'].includes(state.view)) return;
  if (state.view !== 'dashboard') setView('dashboard');
}

